export const otherPaymentOptions = {
  CUSTOM_PAYMENT_PLAN: 'Custom Payment Plan'
};

export const offerTypes = {
  LIGHT_OFFER: 'light',
  PROVIDER_OFFER: 'personalization',
  FINAL_OFFER: 'final'
};
